import React from "react"

import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"

import { ProductCard } from "./ProductCard"
import { useProductCardModel } from "./model/useProductCardModel"

interface ProductCardConnectorProps {
  productObj: ProductObj
}

export const ProductCardConnector = React.memo(
  ({ productObj }: ProductCardConnectorProps) => {
    return <ProductCard {...useProductCardModel({ productObj })} />
  }
)
